import { Grid } from "@mui/material";
import PermissionBox from "./box";



interface iProps {permission_key:string,children:React.ReactElement}

export default function PermissionPage ({permission_key,children}:iProps) {



    return (
        < >
            <
            >
                <PermissionBox
                permission_key={permission_key}

                >
                    {children}
                </PermissionBox>
            </>
        </>
    )
}